import { render, staticRenderFns } from "./other.vue?vue&type=template&id=02cd367d&scoped=true"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=02cd367d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cd367d",
  null
  
)

export default component.exports